import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import LegalDocument from "@/components/legal/LegalDocument";
import PrivacyContent from "@/components/legal/PrivacyContent";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPolicy,
  head: () =>
    seoHead({
      title: "Privacy Policy | Lutely",
      description:
        "How Lutely collects, uses and protects the personal data of artists and fans.",
      canonicalPath: "/privacy",
    }),
});

function PrivacyPolicy() {
  return (
    <LegalDocument title="Privacy Policy">
      <PrivacyContent />
    </LegalDocument>
  );
}
